import {useMemo} from 'react';
import {chainIdToNetworkName} from '../../lib/chains';
import {TNetwork, TToken} from '../../redux/types';
import {selectWallet} from '../../redux/wallet.slice';
import {useAppSelector} from '../hooks';

const useNetworkToken = (tokens?: TToken[], network?: TNetwork) => {
  const {chainId} = useAppSelector(selectWallet);
  const chainName = network?.symbol || chainIdToNetworkName[chainId];

  const networkTokens = useMemo(() => {
    return tokens?.filter(el => el.network?.symbol === chainName) || [];
  }, [chainName, tokens]);

  return {
    tokens: networkTokens,
  };
};

export default useNetworkToken;
